"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./AddReview.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddReview = function AddReview(props) {
  var voornaamInputRef = (0, _react.useRef)();
  var achternaamInputRef = (0, _react.useRef)();
  var imageInputRef = (0, _react.useRef)();
  var starsInputRef = (0, _react.useRef)();
  var textInputRef = (0, _react.useRef)();

  var postApply = function postApply(e) {
    e.preventDefault();

    fetch("https://ourwork-ccaa4-default-rtdb.europe-west1.firebasedatabase.app/reviews/" + props.total + ".json", {
      method: "POST",
      body: JSON.stringify({
        prename: voornaamInputRef.current.value,
        name: achternaamInputRef.current.value,
        image: imageInputRef.current.value,
        stars: starsInputRef.current.value,
        text: textInputRef.current.value,
        id: props.total + 1
      }),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (res) {
      window.location.reload(false);
      // assumption: Always succeeds!
    });
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "form",
      { onSubmit: postApply },
      _react2.default.createElement(
        "div",
        { className: "colFour" },
        _react2.default.createElement("input", {
          type: "text",
          ref: voornaamInputRef,
          placeholder: "voornaam",
          required: true
        }),
        _react2.default.createElement("input", {
          type: "text",
          ref: achternaamInputRef,
          name: "achternaam",
          placeholder: "achternaam",
          required: true
        }),
        _react2.default.createElement("input", {
          type: "text",
          ref: imageInputRef,
          name: "text",
          placeholder: "image",
          required: true
        }),
        _react2.default.createElement("input", {
          type: "number",
          ref: starsInputRef,
          name: "tel",
          placeholder: "cijfer van 1 tot 5",
          min: "1",
          max: "5",
          required: true
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "colTwo" },
        _react2.default.createElement("textarea", {
          htmlFor: "message",
          ref: textInputRef,
          id: "ja_message",
          placeholder: "Motivate us",
          required: true
        }),
        _react2.default.createElement("input", {
          id: "ja_send",
          name: "submit",
          type: "submit",
          value: "Send application"
        })
      )
    )
  );
};

exports.default = AddReview;